import { Injectable } from '@angular/core';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';

import { Provider } from '../../classes/provider';

import { Http, Response, ResponseContentType } from '@angular/http';
import { ExtraParameter } from '../../classes/extraParameter';


@Injectable()
export class ProviderService {

  constructor(protected requestService: RequestService, protected auth: Auth, public http: Http) { }

  get(): Promise<Provider[]> {
    return this.requestService.makeRequest({
      urlKey: 'providerNames'
    })
      .then((response: any) => response.json() as Provider[]);
  };

  getAll(): Promise<Provider[]> {
    return this.requestService.makeRequest({
      urlKey: 'providersAll'
    })
      .then((response: any) => response.json() as Provider);
  };

  getOne(id:any): Promise<Provider> {
    return this.requestService.makeRequest({
      urlKey: 'provider',
      urlParams: {
        id: id
      }
    })
      .then((response: any) => {
       return response.json() as Provider});
  };

  getTC(id:any): any {
    return this.requestService.makeRequest({
      urlKey: 'TCProvider',
      urlParams: {
        id: id
      }
    })
    .then((response: any) => {
      return response.json() as any});
  };

  createTC(body:any): any {
    return this.requestService.makeRequest({
      urlKey: 'TC',
      method: 'post',
      body: JSON.stringify(body)
    })
  }

  updateTC(id:string, body:any): any {
    return this.requestService.makeRequest({
      urlKey: 'TCUpdate',
      urlParams: {
        id: id
      },
      method: 'put',
      body: JSON.stringify(body),
    })
  }

  getDetails(id:any): any {
    return this.requestService.makeRequest({
      urlKey: 'providerDetails',
      urlParams: {
        id: id
      },
    })
    .then((response: any) => {
      return response.json() as any});
  };

  getDoctors(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'doctorProvider',
      urlParams:{
        id:id
      },
    }) .then((response: any) => response.json() as any[]);
  }

  getDoctorsWhoDontBelong(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'doctorProvider',
      urlParams:{
        id:id
      },
      urlQueryParams:{
        "dontBelong":true
      }
    }) .then((response: any) => response.json() as any[]);
  }

  addDoctor(idProvider:string,idDoctor:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'doctorProviderEdit',
      urlParams: {
        id: idProvider,
        doctorId:idDoctor,
      },
      method: 'put',
    });
  }

  removeDoctor(idProvider:string,idDoctor:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'doctorProviderEdit',
      urlParams: {
        id: idProvider,
        doctorId:idDoctor
      },
      method: 'delete',
    });
  }

  getSpecialties(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'specialtyProvider',
      urlParams:{
        id:id
      },
    }) .then((response: any) => response.json() as any[]);
  }

  getSpecialtiesNotInProvider(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'specialtyProvider',
      urlParams:{
        id:id
      },
      urlQueryParams:{
        "dontBelong":true
      }
    }) .then((response: any) => response.json() as any[]);
  }

  getPlans(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'planProvider',
      urlParams:{
        id:id
      },
    }) .then((response: any) => response.json() as any[]);
  }

  getPlansNotInProvider(id:string):Promise<any[]>{
    return this.requestService.makeRequest({
      urlKey:'planProvider',
      urlParams:{
        id:id
      },
      urlQueryParams:{
        "dontBelong":true
      }
    }) .then((response: any) => response.json() as any[]);
  }

  addSpecialty(idProvider:string,idSpec:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderEdit',
      urlParams: {
        id: idProvider,
        specialty:idSpec,
      },
      method: 'put',
    });
  }

  removeSpecialty(idProvider:string,idSpec:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'specialtyProviderEdit',
      urlParams: {
        id: idProvider,
        specialty:idSpec,
      },
      method: 'delete',
    });
  }

  create(newProvider:Provider): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'providers',
      method: 'post',
      body: JSON.stringify(newProvider)
    });
  }

  createParameter(newParameter:ExtraParameter): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'parameters',
      method: 'post',
      body: JSON.stringify(newParameter)
    });
  }

  update(provider: any): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'nativeUpdate',
      urlParams: {
        id: provider.id
      },
      method: 'put',
      body: JSON.stringify(provider)
    });
  }

  delete(provider:Provider): Promise<void> {
    return this.requestService.makeRequest({
      urlKey: 'provider',
      urlParams: {
        id: provider.id
      },
      method: 'delete'
    });
  }

  getServices(): Promise<any[]> {
    return this.requestService.makeRequest({
      urlKey: 'providerServices',
    })
      .then((response: any) => response.json() as any);
  };

  getReports(id): Promise<any[]> {
    return this.requestService.makeRequest({
      urlKey: 'reportsProvider',
      urlParams: {
        id: id
      }
    })
      .then((response: any) => response.json() as Provider);
  };

  getOneReport(id,idReport,params): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'reportProvider',
      urlParams: {
        id: id,
        idReport:idReport
      },
      urlQueryParams: params
    })
      .then((response: any) => response.json() as Provider);
  };

  updateImage(userId: string, obj: any,key: string): Promise<any> {
    return this.requestService.makeRequestImage({
      urlKey: key,//'providerLogo',
      urlParams: {
        id: userId,
      },
      method: 'put',
      body: obj
    })
      .then(() => obj);

  };

  updateAffiliates(id,obj):Promise<any>{
    return this.requestService.makeRequestImage({
      urlKey: 'providerAffiliates',
      urlParams: {
        id: id
      },
      method: 'put',
      body: obj
    });
  }

  updateExtraField(id,endpoint,obj,runNow, allusers: boolean = false):Promise<any>{
    return this.requestService.makeRequestImageWithEndpoint({
      urlParams: {
        id: id
      },
      method: 'put',
      body: obj,
      urlQueryParams: {
        runNow : runNow,
        allusers : allusers
      }
    },endpoint)
    .then((response) => {
      return response

    })
  }

  updateVademecum(id,obj):Promise<any>{
    return this.requestService.makeRequestImage({
      urlKey: 'providerVademecum',
      urlParams: {
        id: id
      },
      method: 'put',
      body: obj
    });
  }

  getAppointmentAttachments(id: string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlKey: 'providerAppointmentAttachments',
      urlParams: {
        id
      },
    })
    .then((response: any) => {
      return response.json()
    });
  }

  updateAppointmentAttachments(id,obj):Promise<any>{
    return this.requestService.makeRequestImage({
      urlKey: 'providerAppointmentAttachments',
      urlParams: {
        id: id
      },
      method: 'put',
      body: obj
    }).then((response: any) => {
      return JSON.parse(response)
    });
  }

  removeAppointmentAttachments(id, fileName):Promise<any>{
    return this.requestService.makeRequest({
      urlKey: 'providerAppointmentAttachmentsRemove',
      urlParams: {
        id: id
      },
      method: 'put',
      body: {
        fileName
      }
    }).then((response: any) => response.json() as any);
  }
  useExtraField(id,endpoint): Promise<any> {
    return this.requestService.makeRequest({
      urlParams: {
        id: id,
      },
    },endpoint)
      .then((response: any) => response.json() as any);
  };

  getLanguages():Promise<any>{
    return this.requestService.makeRequest({
      urlKey:'languages'
    }).then((response)=> response.json() as any)
  }

  getProviderLanguages():Promise<any>{
    return this.requestService.makeRequest({
      urlKey:'supportedLanguages'
    }).then((response)=> response.json() as any)
  }

  getParameters(): Promise<ExtraParameter[]> {
    return this.requestService.makeRequest({
      urlKey: 'parameters'
    })
      .then((response: any) => response.json() as ExtraParameter);
  };

  getSatisfactionSurveyQuestions(providerId):Promise<any[]> {
    return this.requestService.makeRequest({
      urlParams: {
        id: providerId,
      },
      urlKey: 'providerSatisfactionSurveyQuestions'
    })
    .then((response: any) => response.json() as Provider[]);
  }

  getWithoutPriority(): Promise<Provider[]> {
    return this.requestService.makeRequest({
      urlKey: 'providerWithoutPriority'
    })
      .then((response: any) => response.json() as Provider[]);
  };

  getWithPriority():Promise<Provider[]> {
    return this.requestService.makeRequest({
      urlKey: 'providerWithPriority'
    })
      .then((response: any) => response.json() as Provider[]);
  }

  movePriority(id:string, to:string){
    return this.requestService.makeRequest({
      urlKey:'moveProviderPriority',
      method:'put',
      body:{
        id:id,
        change: to
      }
    })
  }

  removePriority(id:string){
    return this.requestService.makeRequest({
      urlKey:'removeProviderPriority',
      method:'put',
      body:{
        id:id,
      }
    })
  }

  addLanguage(id:string, languageId:string){
    return this.requestService.makeRequest({
      urlKey:'updateLanguage',
      method:'put',
      urlParams:{
        id:id,
        languageId:languageId
      }
    })
  }

  removeLanguage(id:string, languageId:string){
    return this.requestService.makeRequest({
      urlKey:'updateLanguage',
      method:'delete',
      urlParams:{
        id:id,
        languageId:languageId
      }
    })
  }

  addAllDoctors(idProvider:string, country:string, onlyLadDoctors:boolean): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'addAllDoctors',
      urlParams: {
        id: idProvider,
      },
      body:{
        country: country,
        onlyLadDoctors: onlyLadDoctors,
      },
      method: 'put',
    });
  }

  removeAllDoctors(idProvider:string, country:string, onlyLadDoctors:boolean): Promise<any> {
    return this.requestService.makeRequest({
    urlKey: 'removeAllDoctors',
      urlParams: {
        id: idProvider,
      },
      body:{
        country: country,
        onlyLadDoctors: onlyLadDoctors,
      },
      method: 'put',
    });
  }

  addDoctorToAllProvidersAndPriorities(doctorId:string, country:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'doctorAddToAllProviders',
      urlParams: {
        id: doctorId,
      },
      body:{
        country: country
      },
      method: 'put',
    });
  }

  removeDoctorFromAllProvidersAndPriorities(doctorId:string): Promise<any> {
    return this.requestService.makeRequest({
      urlKey: 'doctorRemoveFromAllProviders',
      urlParams: {
        id: doctorId,
      },
      method: 'put',
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/providers/provider.service.ts